import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SocialPostType } from '../promote/types';
import { socialPostTypeMessages } from './socialMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialPostTypeBadgeProps {
  type: SocialPostType;
}

/** What a post is on its platform: Reel, Short, Video, Photo, Carousel, Text or Story. */
const SocialPostTypeBadgeComponent: React.FC<SocialPostTypeBadgeProps> = ({ type }) => {
  const intl = useIntl();
  const isVideo = type === 'reel' || type === 'short' || type === 'video';

  return (
    <span className={clsx(styles.typeBadge, isVideo && styles.typeBadgeVideo)} data-testid="social-post-type">
      {intl.formatMessage(socialPostTypeMessages[type])}
    </span>
  );
};

export const SocialPostTypeBadge = TypedMemo(SocialPostTypeBadgeComponent);
